export default "__VITE_ASSET__1eec82bd__"